export default __webpack_public_path__ + "static/media/token_none.9c61a69f.svg";